<template>
  <div class="listbox">
    <component
      v-if="options.customTable"
      :is="options.customTable"
      ref="table"
      :scrollY="scrollY"
      :height="height"
      :data="data"
      :column="column"
      :operation="operation"
      :options="options"
      :buttonOptions="buttonOptions"
      :imageOptions="imageOptions"
      :checkedOptions="checkedOptions"
      :uploadOptions="uploadOptions"
      :sortOptions="sortOptions"
      :drawColumnOptions="drawColumnOptions"
      :layerColumnOptions="layerColumnOptions"
      :headRenderOptions="headRenderOptions"
      :headerTipOptions="headerTipOptions"
      :selection="options.type === 'selection'"
      :page="page"
      :pageable="pageable"
      :dialog="dialog"
      :fixed-header="fixedHeader"
      :offset-left="offsetLeft"
      @cell-click="cellClick"
      @any-cell-click="anyCellClick"
      @row-click="rowClick"
      @row-dblclick="rowDblClick"
      @current-change="currentChange"
      @selection-change="selectionChange"
      @row-edit="handleCommand"
      @cell-checkbox="onCheckChange"
      @cell-upload="onClickUpload"
      @sort-change="sortChange"
      @switch-menu="e => $emit('switch-menu', e)"
      @btn-dbclick="btnDbclick"
      @col-resize="saveColWidth"
      @edit-mode="editMode"
      @header-move="headerMove"
      @cell-move="e => $emit('cell-move', e)"
      @any-cell-move="anyCellMove"
      @table-leave="tableLeave"
      @table-scroll="tableScroll"
      @close-edit-mode="closeEditMode">
    </component>
    <kye-canvas-table
      v-else
      ref="table"
      :scrollY="scrollY"
      :height="height"
      :data="data"
      :column="column"
      :operation="operation"
      :options="options"
      :buttonOptions="buttonOptions"
      :imageOptions="imageOptions"
      :checkedOptions="checkedOptions"
      :uploadOptions="uploadOptions"
      :sortOptions="sortOptions"
      :drawColumnOptions="drawColumnOptions"
      :layerColumnOptions="layerColumnOptions"
      :headRenderOptions="headRenderOptions"
      :headerTipOptions="headerTipOptions"
      :selection="options.type === 'selection'"
      :page="page"
      :pageable="pageable"
      :dialog="dialog"
      :fixed-header="fixedHeader"
      :offset-left="offsetLeft"
      :beforeDraws="beforeDraws"
      @cell-click="cellClick"
      @any-cell-click="anyCellClick"
      @row-click="rowClick"
      @row-dblclick="rowDblClick"
      @current-change="currentChange"
      @selection-change="selectionChange"
      @row-edit="handleCommand"
      @cell-checkbox="onCheckChange"
      @cell-upload="onClickUpload"
      @sort-change="sortChange"
      @switch-menu="e => $emit('switch-menu', e)"
      @btn-dbclick="btnDbclick"
      @col-resize="saveColWidth"
      @edit-mode="editMode"
      @header-move="headerMove"
      @cell-move="e => $emit('cell-move', e)"
      @any-cell-move="anyCellMove"
      @table-leave="tableLeave"
      @table-scroll="tableScroll"
      @close-edit-mode="closeEditMode">
      <slot slot="tooltip"></slot>
    </kye-canvas-table>
    <!-- 上传 -->
    <kye-upload
      v-if="uploadkey"
      style="display: none"
      ref="upload"
      :code="uploadOptions[uploadkey].code"
      :id="uploadId"
      list-type="text"
      :show-file-list="false"
      :size="uploadOptions[uploadkey].size"
      @success="uploadSuccess"
      v-model="fileList">
    </kye-upload>
    <!-- 编辑插槽渲染 -->
    <template v-if="mode">
      <div class="eidtRender" :style="editStyle" v-show="showMode">
        <edit-render
          :crender="options.editRender"
          :row="editProps.row"
          :col="editProps.col"
          :value="editProps.value"
          :index="editProps.index"></edit-render>
      </div>
    </template>

    <call-dialog
      ref="callDialog"
      v-bind="callProps"
      @save="$emit('call-save')"/>
  </div>
</template>

<script>
  import mixins from '../../mixins'
  import TablePlugin from './module/table-cell-plugin'
  import { initColWidth, setHistoryDataByDragColumn } from './module/table-column'
  import tableHeaderPlugin from './module/table-header-plugin'
  import { decrypt, getModalPageName, getModelValue } from '../../utils'
  import { procesingMaxDecrypt, createKeys } from '../../utils/decrypt-max-plugin'
  import KyeCanvasTable from '../kye-canvas-table'
  import { headerHeight, rowHeight, cellPaddingWidth } from '../kye-canvas-table/config'
  import { AUTO_WIDTH } from '../kye-canvas-table/mixins/calculate'
  import EditRender from './edit-render'
  import CallDialog from '../kye-field-call/call-dialog'
  import phoneImg from '../kye-field-call/phone.svg'
  const DEFAULT_HEIGHT = headerHeight + 10 * rowHeight
  const PHONE_FONT_SIZE = 14

  const PHONE = new Image()
  PHONE.src = phoneImg

  export default {
    mixins: [mixins],
    name: 'table-list',
    components: { KyeCanvasTable, EditRender, CallDialog },
    props: {
      scrollY: Boolean,
      page: Object,
      pageable: Boolean,
      dialog: Boolean,
      fixedHeader: Boolean,
      maxHeight: [Function, Number],
      minHeight: [Function, Number],
      offsetLeft: Number,
      searchCode: String,
      data: Array,
      options: {
        type: Object,
        default: () => ({})
      },
      column: Array,
      operation: Object,
      buttonOptions: Object,
      imageOptions: Object,
      checkedOptions: Object,
      uploadOptions: Object,
      sortOptions: Object,
      headRenderOptions: {
        type: Object,
        default: () => ({})
      },
      drawColumnOptions: {
        type: Object,
        default: () => ({})
      },
      layerColumnOptions: {
        type: Object,
        default: () => ({})
      },
      headerTipOptions: Object,
      maxDecryptConfig: Object,
      callProps: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        height: DEFAULT_HEIGHT,
        fileList: [],
        uploadRow: null,
        uploadId: '',
        editProps: {
          row: {},
          col: {},
          value: '',
          index: 0
        },
        editStyle: {
          left: `0px`,
          top: `0px`,
          width: `100px`
        },
        showMode: false,
        beforeDraws: []
      }
    },
    created () {
      this.tableKey = `${this.$route.meta.tag}?${this.searchCode}`
      // 检查是否存在绘制前callback
      this.addBeforeDraw()
    },
    mounted () {
      TablePlugin(this)
      tableHeaderPlugin(this)
      this.setColWidth()
      if (this.dialog && !this.maxHeight) {
        setTimeout(_ => {
          this.handleDialogHeight()
        }, 310)
      } else {
        this.setCanvasHeight()
      }
    },
    computed: {
      uploadkey () {
        if (this.uploadOptions && Object.keys(this.uploadOptions).length > 0) {
          return Object.keys(this.uploadOptions)[0]
        }
        return ''
      },
      mode () {
        return this.options && this.options.mode === 'edit'
      }
    },
    watch: {
      column (val) {
        this.setLayerColumnOptions()
        this.initColWidth(val)
        this.updateCacheColumnWidth()
      },
      data () {
        // 表格自动加载，重新计算表格高度
        if (this.dialog && !this.maxHeight && this.options.load) {
          setTimeout(_ => {
            this.handleDialogHeight()
          }, 300)
        }
      },
      // 2023-02-28 表格动态自定义列 searchCode 场景
      searchCode () {
        this.tableKey = `${this.$route.meta.tag}?${this.searchCode}`
      }
    },
    methods: {
      // 测试 tableKey 是否出现不一致情况
      testCode () {
        const menuId = this.$store.state.menus && this.$store.state.menus[this.$route.meta.tag] && this.$store.state.menus[this.$route.meta.tag].id
        const tableKey = this.tableKey
        const actTabelKey = `${this.$route.meta.tag}?${this.searchCode}`
        if (tableKey !== actTabelKey) {
          this.$logReport({
            menuId: menuId || '2820215716730110', // 菜单id
            logId: 'public-drag-width', // 日志id 建议：部门标识 + 编码，方便识别
            log: `dataKey0=${tableKey}，dataKey1=${actTabelKey}` // 日志详情
          })
        }
      },
      repaint (val) {
        if (this.options.mode === 'edit') {
          this.$refs.table.editRepaint(val, this.showMode)
        } else {
          this.$refs.table.repaint()
        }
      },
      setCanvasWidth () {
        this.$refs.table.setCanvasWidth()
        this.setCanvasHeight()
      },
      setCanvasHeight () {
        this.$nextTick(_ => {
          if (this.maxHeight || this.dialog) {
            if (this.maxHeight) {
              this.height = typeof this.maxHeight === 'function' ? this.maxHeight() : this.maxHeight
            } else {
              this.handleDialogHeight()
            }
          } else {
            let dis = this.$el.getBoundingClientRect().top + 58
            let height = window.innerHeight - dis
            this.height = this.fixedHeader && height < DEFAULT_HEIGHT ? DEFAULT_HEIGHT : height
          }
        })
      },
      handleDialogHeight () {
        // TODO：高度并没有统一入口去进行设置，目前只处理了dialog模式下的最小高度
        const _minHeight = this.minHeight ? this.getMinHeight() : 0
        // tabs+单行表单+工具栏+统计栏+弹框头部   38+32+30+32+44
        let top = this.$el.offsetTop
        top = (top > 0 && top <= 176) ? top - 44 + 16 : 28
        const _height = Math.floor(window.innerHeight * 0.6) - top
        this.height = _minHeight ? Math.max(_minHeight, _height) : _height
      },
      getMinHeight() {
        return parseInt(typeof this.minHeight === 'function' ? this.minHeight() : this.minHeight) || 0
      },
      async cellClick (row, column, val, markrow, mask, virtual, params) {
        const key = column.key
        if (!column._showButton) {
          if (column.customClickFlag) {
            this.$emit('cell-click', markrow, column, val, this.$refs.table.showSlotToolTip)
          }
          return
        }
        // 字段如果被批量解密，mask判断有误，需判断字段是否已经批量解密
        const { keyDecryptOrder } = createKeys(key)
        const hasBatchDecrypt = markrow.hasOwnProperty(keyDecryptOrder)
        const isMask = !hasBatchDecrypt && mask

        // 2023-01-05 当用户知道字段可能存在加密或者虚拟号额情况下使用。需绕过func方法时，在解密字段前使用
        const beforeDecrypt = this.buttonOptions && this.buttonOptions[key] && this.buttonOptions[key].beforeDecrypt
        if (beforeDecrypt && typeof beforeDecrypt === 'function' && beforeDecrypt(row, column, { markrow, mask: isMask, virtual }) === true) {
          return null
        }

        const ownerClick = this.buttonOptions && this.buttonOptions[key] && this.buttonOptions[key].func
        // 判断字段是否支持解密，需排除单元格是否有额外场景（点击事件、单元格呼叫）
        if ((isMask || virtual) && !ownerClick && !this.canClickCallNumber(column, params.x)) {
          await this.handleDecrypt(row, markrow, column)
        } else {
          ownerClick && ownerClick(row, markrow, _ => this.$refs.table.repaint())
        }

        // 2023-01-05 当用户知道字段可能存在加密或者虚拟号额情况下使用。需绕过func方法时，在解密字段后使用
        const afterDecrypt = this.buttonOptions && this.buttonOptions[key] && this.buttonOptions[key].afterDecrypt
        if (afterDecrypt) {
          afterDecrypt(row, column, { markrow, mask: isMask, virtual })
        }
        this.$emit('cell-click', markrow, column, val, this.$refs.table.showSlotToolTip)
      },
      // 解密字段
      async handleDecrypt (row, markrow, column) {
        const key = column.key
        const mask = markrow.hasOwnProperty(key + 'Mask')
        const virtual = markrow.hasOwnProperty(key + 'Virtual')
        const res = await decrypt({
          dataId: getModelValue(row, this.options.bizIdKey || 'id') || '0',
          moduleCode: this.options.moduleCode,
          fieldName: key,
          fieldContent: markrow[`${key}Mask`] || markrow[`${key}Virtual`],
          fieldNameStr: column.label || '',
          buttonName: getModalPageName(this),
          operateReason: 'kye-decrypt',
          autoFocus: false // 2022-10-28 关闭解密提示框时，不自动聚焦回canvas元素（否则部分页面会抖一下）
        }, mask ? 'mask' : 'virtual')

        if (res !== null) {
          // 配置最大解密限制【maxDecryptConfig】时使用
          if (mask) {
            procesingMaxDecrypt(this.maxDecryptConfig, this.$refs.table.flatData, markrow, key, this.options, row.id)
          }
          // 金额、数据字典等解密后也需要 formatter
          markrow[key] = column.formatter ? column.formatter(row, column, res) : res
          if (mask) {
            delete markrow[`${key}Mask`]
          }
          if (virtual) {
            delete markrow[`${key}Virtual`]
          }
          this.$emit('decrypt-success', { row, markrow, key, mask, virtual, vm: this.$refs.table })
          this.$refs.table.repaint()
        }
      },
      anyCellClick (e) {
        const { column, value, rowData, x } = e
        const key = column.key
        if (this.canClickCallNumber(column, x)) {
          this.$refs.callDialog.init({
            callNumber: value,
            calledNumberEncrypt: rowData[`${key}Mask`] || rowData[`${key}Virtual`] || rowData[`${key}MaskSec`] || '',
            succsss: () => {
              this.$emit('call-success', { rowData, column })
            }
          })
        }
        this.$emit('any-cell-click', e)
      },
      anyCellMove (e) {
        this.$emit('any-cell-move', e)
      },
      headerMove (e) {
        this.$emit('header-move', e)
      },
      tableLeave (e) {
        this.$emit('table-leave', e)
      },
      tableScroll(e) {
        this.$emit('table-scroll', e)
      },
      canClickCallNumber (column, mouseX) {
        const { scroll, ratio } = this.$refs.table
        const cx = (column.width + column.x - scroll.disx - PHONE_FONT_SIZE - cellPaddingWidth) / ratio
        return column.callNumberWidget && cx < mouseX
      },
      setLayerColumnOptions () {
        if (this.column && this.column.length) {
          this.column.forEach(col => {
            if (col.callNumberWidget && !this.layerColumnOptions[col.key]) {
              this.layerColumnOptions[col.key] = (ctx, { row, col, x, y, disx, disy, text, canvasTable }) => {
                const { ratio } = canvasTable
                let w = PHONE_FONT_SIZE * ratio
                ctx.drawImage(PHONE, x + col.width - cellPaddingWidth * 2 * ratio - w, y - w / 2, w, w)
              }
            }
          })
        }
      },
      rowDblClick (row, column, value) {
        if (this.options.rowDblClick) {
          let auth = this.options.detailAuth
          auth = auth === false || (auth && this.permission.menus.includes(auth))
          if (!auth) {
            this.$message.warning('无权访问')
            return
          }
          this.options.rowDblClick(row, column, value)
        }
      },
      btnDbclick (row, col) {
        col.dbclick(row)
      },
      rowClick (rowData, column, value, row, x, y) {
        if (this.options.rowClick) {
          this.options.rowClick(rowData, column, value, row, x, y)
        }
      },
      currentChange (val) {
        if (this.options.currentChange) {
          this.options.currentChange(val)
        }
      },
      selectionChange (arr, isAllChecked, options) {
        if (this.options.type === 'selection' && this.options.selectionChange) {
          this.options.selectionChange(arr, isAllChecked, options)
        }
      },
      handleCommand (row, column, value, btn, e, opt) {
        if (!(btn && btn.func) || this.buttonDisabled(btn.disabled, row)) {
          return
        }
        if (btn.type === 'link') {
          let route = (typeof btn.func === 'function') ? btn.func(row, btn) : btn.func
          route && this.$router.push(route)
        } else {
          btn.func(row, btn, opt)
        }
      },
      onCheckChange (row, key, opt) {
        this.checkedOptions[key].func && this.checkedOptions[key].func(row, key, opt)
      },
      uploadSuccess (list) {
        const { uploadOptions, uploadkey } = this
        if (typeof uploadOptions[uploadkey].success === 'function') {
          uploadOptions[uploadkey].success(list, this.uploadRow)
        }
      },
      onClickUpload (row, key) {
        const { uploadOptions, uploadkey } = this
        if (typeof uploadOptions[uploadkey].id === 'function') {
          this.uploadId = uploadOptions[uploadkey].id(row)
        } else {
          this.uploadId = uploadOptions[uploadkey].id
        }
        this.uploadRow = row
        this.$refs.upload.manualUpload()
      },
      sortChange (e) {
        this.$emit('sort-change', e)
      },
      buttonDisabled (func, row) {
        return typeof func === 'function' ? func(row) : func
      },
      saveColWidth (key, width) {
        if (!this.searchCode || ['$$index', '$$selection'].includes(key)) {
          return
        }
        let res = localStorage.getItem('GLOBAL_COL_WIDTH')
        let tag = this.tableKey
        if (res) {
          try {
            res = JSON.parse(res)
            if (res[tag]) {
              res[tag][key] = width
            } else {
              res[tag] = { [key]: width }
            }
            localStorage.setItem('GLOBAL_COL_WIDTH', JSON.stringify(res))
          } catch (e) {
          }
        } else {
          res = { [tag]: { [key]: width } }
          localStorage.setItem('GLOBAL_COL_WIDTH', JSON.stringify(res))
        }
        setHistoryDataByDragColumn(tag, key, this.column)
        // 这里是特写给表格工具使用的
        this.$emit('column-width-change', width, undefined, { key })
      },
      updateCacheColumnWidth () {
        // 2023-01-19 初始化列宽，对比前后是否发生变化
        if (this.searchCode && this.column.length && !this.isInitHistoryColWidth) {
          let tag = this.tableKey
          this.isInitHistoryColWidth = true
          initColWidth(tag, this.column)
          // this.setColWidth()
          this.testCode()
        }
      },
      setColWidth () {
        let res = localStorage.getItem('GLOBAL_COL_WIDTH')
        if (this.searchCode && res) {
          try {
            let tag = this.tableKey
            res = JSON.parse(res)
            res = res[tag]
            if (res) {
              this.$refs.table.colWidthMap = res
            }
          } catch (e) {
            const tag = this.$vnode ? this.$vnode.tag : ''
            const menuId = this.$store.state.menus && this.$store.state.menus[this.$route.meta.tag] && this.$store.state.menus[this.$route.meta.tag].id
            let refArr = this.$refs
            refArr = refArr ? Object.keys(refArr) : []
            this.$logReport({
              menuId: menuId || '2820215716730110', // 菜单id
              logId: 'public-drag-width', // 日志id 建议：部门标识 + 编码，方便识别
              log: JSON.stringify(e.message + e.stack), // 日志详情
              ext1: localStorage.getItem('GLOBAL_COL_WIDTH'),
              ext2: localStorage.getItem('GLOBAL_COL_HISTORY_WIDTH'),
              ext3: `refs=${JSON.stringify(refArr)}，tag=${tag}，customTable=${Boolean(this.options.customTable)}`
            })
          }
        }
      },
      // 列宽兜底处理
      initColWidth (arr) {
        if (arr && this.$refs.table && this.$refs.table.textCtx) {
          const ctx = this.$refs.table.textCtx
          arr.forEach(v => {
            // 没有设置列宽或者列宽过小，则根据表头字符个数来设置列宽
            // 字体大小12px, padding: 0 6px, 排序图标8px
            if (v.safeWidth !== false) {
              let mixWidth = 12 + (ctx.measureText(v.label).width || v.label.length * 12)
              if (v.sortKeys && v.sortKeys.length) {
                mixWidth += 8
              }
              let width = parseInt(v.width || '')
              if (v.width !== AUTO_WIDTH) { // 如果是 “auto”则计算最小值, auto需要根据数据来计算
                if (!width || width < mixWidth) {
                  width = mixWidth
                  // console.error(`【QueryTable】 【${v.label}(${v.key})】列宽设置错误，当前列宽设置过短，表头展示不全，建议设置为 auto 或者大于${mixWidth}'px'`)
                }
                v.width = width
              }
            }
          })
        }
      },
      editMode (opts) {
        let { left, top, width, row, col, value, index } = opts
        this.editStyle = {
          left: `${left}px`,
          top: `${top - 1}px`,
          width: `${width}px`
        }
        this.editProps = { row, col, value, index }
        this.showMode = true
      },
      closeEditMode () {
        this.showMode = false
      },
      setScrollLeft (left) {
        this.$refs.table && this.$refs.table.setScrollLeft(left)
      },
      clearSort () {
        this.$refs.table && this.$refs.table.clearSort()
      },
      addBeforeDraw() {
        const { options } = this.$props
        if (typeof options.beforeDraw === 'function') {
          const isHasBeforeDraw = this.beforeDraws.find(fn => fn === options.beforeDraw)
          if (!isHasBeforeDraw) {
            this.beforeDraws.push(options.beforeDraw)
          }
        }
      }
    }
  }
</script>

<style lang="postcss" scoped>
  .listbox {
    position: relative;
  }

  .eidtRender {
    position: absolute;
    top: -10000px;
    left: -10000px;
    color: #000000;
    font-size: 13px;
    background-color: #ffffff;
    z-index: 10;
    box-sizing: border-box;
    height: 29px;
    overflow: hidden;
    overflow-y: auto;
    word-break: break-all;
    border: 1px solid #7653d6;
  }
</style>



// WEBPACK FOOTER //
// src/public/components/query-table/table-list.vue